export const API = (import.meta as any).env?.VITE_API_URL || '/api';
const jsonHeaders = { 'Content-Type': 'application/json' };

export async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const response = await fetch(`${API}${path}`, {
    ...init,
    credentials: 'same-origin',
    headers: { ...jsonHeaders, ...(init.headers || {}) },
  });
  if (!response.ok) {
    let detail = 'Falha na operação';
    try {
      const data = await response.json();
      detail = data.detail || detail;
    } catch {}
    throw Object.assign(new Error(detail), { status: response.status });
  }
  if (response.status === 204) return undefined as T;
  const type = response.headers.get('content-type') || '';
  return (type.includes('application/json') ? response.json() : response.text()) as Promise<T>;
}

export const api = {
  get: <T>(path: string) => request<T>(path),
  post: <T>(path: string, body?: any) => request<T>(path, { method: 'POST', body: body === undefined ? undefined : JSON.stringify(body) }),
  put: <T>(path: string, body: any) => request<T>(path, { method: 'PUT', body: JSON.stringify(body) }),
  patch: <T>(path: string, body: any) => request<T>(path, { method: 'PATCH', body: JSON.stringify(body) }),
  delete: <T>(path: string) => request<T>(path, { method: 'DELETE' }),
  upload: async <T>(path: string, form: FormData) => {
    const response = await fetch(`${API}${path}`, { method: 'POST', credentials: 'same-origin', body: form });
    if (!response.ok) {
      const d = await response.json().catch(() => ({}));
      throw Object.assign(new Error(d.detail || 'Falha no envio'), { status: response.status });
    }
    return response.json() as Promise<T>;
  },
  fileUrl: (path: string) => `${API}${path}`,
};
